import React from "react";
import { Region } from "../types";

interface RegionalRiskSnapshotProps {
  regions: Region[];
}

export const RegionalRiskSnapshot: React.FC<RegionalRiskSnapshotProps> = ({
  regions,
}) => {
  return (
    <article className="relative p-4 pb-4.5 rounded-[18px] bg-gradient-to-br from-[#22284d] to-[#10142f] border border-[rgba(139,146,176,0.2)] shadow-[0_16px_40px_rgba(0,0,0,0.6)] overflow-hidden">
      <div className="flex items-center justify-between gap-2 mb-2.5">
        <div className="flex flex-col gap-0.5">
          <div className="text-[15px] font-medium tracking-[0.06em] uppercase">
            Regional risk snapshot
          </div>
          <div className="text-[11px] text-[#8b92b0]">
            Rolling default/LTV snapshot by metro region.
          </div>
        </div>
        <span className="rounded-full px-2 py-0.5 text-[10px] uppercase tracking-[0.12em] border border-[rgba(139,146,176,0.6)] text-[#8b92b0]">
          Default · 90D
        </span>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-1.5 sm:grid-cols-2">
        {regions.map((region) => (
          <div
            key={region.name}
            className={`relative p-2 pb-2.25 rounded-[10px] bg-[rgba(5,7,22,0.9)] border border-[rgba(139,146,176,0.35)] overflow-hidden cursor-pointer transition-all duration-150 text-[11px] hover:border-[rgba(0,212,255,0.7)] hover:-translate-y-0.5 hover:shadow-[0_12px_34px_rgba(0,0,0,0.6)] ${
              region.risk === "medium"
                ? "medium"
                : region.risk === "high"
                ? "high"
                : ""
            }`}
            style={{
              background:
                region.risk === "medium"
                  ? "linear-gradient(135deg, transparent, rgba(255, 184, 0, 0.26))"
                  : region.risk === "high"
                  ? "linear-gradient(135deg, transparent, rgba(255, 51, 102, 0.36))"
                  : "linear-gradient(135deg, transparent, rgba(0, 212, 255, 0.16))",
            }}
          >
            <div className="flex justify-between items-center gap-1 relative z-[1]">
              <span className="text-[11px] font-medium">{region.name}</span>
              <span
                className={`w-1.75 h-1.75 rounded-full border border-[rgba(0,0,0,0.6)] ${
                  region.risk === "low"
                    ? "bg-[rgba(0,255,136,0.9)]"
                    : region.risk === "medium"
                    ? "bg-[rgba(255,184,0,0.9)]"
                    : "bg-[rgba(255,51,102,0.9)]"
                }`}
              />
            </div>
            <div className="font-jetbrains-mono text-[13px] font-semibold relative z-[1]">
              {region.value}
            </div>
            <div className="mt-0.5 text-[10px] text-[#8b92b0] relative z-[1]">
              {region.loans} loans · avg LTV {region.ltv}%
            </div>
          </div>
        ))}
      </div>

      <div className="text-[11px] text-[#8b92b0] mt-2">
        <span className="text-neon-green">● Low &lt; 2.5%</span>
        &nbsp;&nbsp;
        <span className="text-warning-amber">● Medium 2.5–3.5%</span>
        &nbsp;&nbsp;
        <span className="text-error-red">● High &gt; 3.5%</span>
      </div>
    </article>
  );
};
